import { render, staticRenderFns } from "./ContentCatalogue.vue?vue&type=template&id=611a604e"
import script from "./ContentCatalogue.vue?vue&type=script&lang=js"
export * from "./ContentCatalogue.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports